// extracted by mini-css-extract-plugin
export default {"title":"mIOl9m","sub-title":"w5_Io5","subTitle":"w5_Io5"};